import { Link } from 'react-router-dom';
import type { Manhwa } from '@/mocks/manhwa';

export default function ManhwaCard({ item }: { item: Manhwa }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl bg-background-50 border border-background-200 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={`${item.title} 封面`}
          title={`${item.title} 韩漫推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2.5 top-2.5 rounded-full bg-background-950/70 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
          {item.status}
        </span>
        <span className="absolute right-2.5 top-2.5 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-950">
          <i className="ri-star-fill" /> {item.score.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-0.5 text-xs text-foreground-500">{item.author}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
        <p className="mt-3 line-clamp-2 text-xs leading-5 text-foreground-600">{item.summary}</p>
      </div>
    </Link>
  );
}